module.exports = __webpack_public_path__ + "static/media/information-solid.7f85c7ec.svg";